import axios from "axios";
import authHeader from "./auth-header";

const API_URL = `${process.env.VUE_APP_API_BASE_URL}/api/Feature/Warehouse`;

class WarehouseService {
  getAllWarehouses() {
    return axios
      .get(`${API_URL}/All`, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }

  //#region Advance
  getAdvance(warehouseLenderId) {
    return axios
      .get(`${API_URL}/Advance/Get/${warehouseLenderId}`, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }

  createAdvance(jnl) {
    return axios
      .post(`${API_URL}/Advance/Create`, jnl, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }

  updateAdvance(jnlId, updateJnl) {
    return axios
      .put(`${API_URL}/Advance/Update/${jnlId}`, updateJnl, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }

  deleteAdvance(jnlId) {
    return axios
      .delete(`${API_URL}/Advance/Delete/${jnlId}`, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  //#endregion

  //#region Fee
  getFee(warehouseLenderId) {
    return axios
      .get(`${API_URL}/Fee/Get?warehouseLenderId=${warehouseLenderId}`, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }

  createFee(jnlWarehouseFee) {
    return axios
      .post(`${API_URL}/Fee/Create`, jnlWarehouseFee, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }

  updateFee(jnlId, updateJnl) {
    return axios
      .put(`${API_URL}/Fee/Update/${jnlId}`, updateJnl, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }

  deleteFee(jnlId) {
    return axios
      .delete(`${API_URL}/Fee/Delete/${jnlId}`, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  //#endregion

  //#region IntRate
  getIntRate(warehouseLenderId) {
    return axios
      .get(`${API_URL}/IntRate/${warehouseLenderId}`, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }

  createIntRate(jnl) {
    return axios
      .post(`${API_URL}/IntRate/Create`, jnl, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }

  updateIntRate(jnlId, updateJnl) {
    return axios
      .put(`${API_URL}/IntRate/Update/${jnlId}`, updateJnl, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }

  deleteIntRate(jnlId) {
    return axios
      .delete(`${API_URL}/IntRate/Delete/${jnlId}`, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  //#endregion

  getAdvanceInformation(fileName, loanPurchaseDate) {
    return axios
      .get(
        `${API_URL}/GetAdvanceInformation?fileName=${fileName}&loanPurchaseDate=${loanPurchaseDate}`,
        {
          headers: authHeader(),
        }
      )
      .then((response) => {
        return response;
      });
  }

  setLoanPurchaseDate(fileName, setData) {
    return axios
      .put(`${API_URL}/SetLoanPurchaseDate?fileName=${fileName}`, setData, {
        headers: authHeader(),
      })
      .then((response) => {
        return response;
      });
  }
}

export default new WarehouseService();
